import './sw-boxes-types.component.js';
import './sw-boxes-products.component.js';